/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Summary_NextInputs */

const en_us2_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The next week has already started.`)
};

const pt_br2_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A próxima semana já começou.`)
};

const es_419_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La próxima semana ya empezó.`)
};

const pt_pt2_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A próxima semana já começou.`)
};

const fr_fr2_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La semaine suivante a déjà commencé.`)
};

const de_de2_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die nächste Woche hat schon begonnen.`)
};

const it_it2_wrapped_summary_next = /** @type {(inputs: Wrapped_Summary_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prossima settimana è già iniziata.`)
};

/**
* | output |
* | --- |
* | "The next week has already started." |
*
* @param {Wrapped_Summary_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_summary_next = /** @type {((inputs?: Wrapped_Summary_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Summary_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_summary_next(inputs)
	if (locale === "es-419") return es_419_wrapped_summary_next(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_summary_next(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_summary_next(inputs)
	if (locale === "de-DE") return de_de2_wrapped_summary_next(inputs)
	if (locale === "it-IT") return it_it2_wrapped_summary_next(inputs)
	return en_us2_wrapped_summary_next(inputs)
});
export { wrapped_summary_next as "wrapped.summary_next" }